export default function CalendarController(
    $scope,
    searchUrl,
    siteService,
    Scroll
) {
    searchUrl.init().then((res) => {
        $scope.activity = res.activity;
        $scope.location = res.location;
        $scope.date = res.date;

        console.log("scroll now");

        Scroll.to("title-focus", siteService.headerHeight + 15);
    });
}
